declare global {
  interface Window {
    Razorpay?: any;
  }
}

// Same lazy-script-tag pattern as loadGoogleMaps — Razorpay's Checkout.js
// isn't npm-installable as a browser bundle (it's meant to be loaded this
// way), and we only want it fetched for tenants who actually reach the
// payment button, not on every page load.
let loadPromise: Promise<void> | null = null;
export function loadRazorpayCheckout(): Promise<void> {
  if (window.Razorpay) return Promise.resolve();
  if (loadPromise) return loadPromise;
  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => {
      loadPromise = null;
      reject(new Error("Failed to load Razorpay checkout"));
    };
    document.head.appendChild(script);
  });
  return loadPromise;
}
